import { LEERER_RUECKSTAND, type Rueckstandszahlen } from '../domain/rueckstand';
import { pendingLogs } from '../persistence/examLog';
import type { Store } from '../persistence/port';
import { aktuelleNamensform } from '../platform/storage';

import { anhangStand } from './anhaenge';
import { classicDateistand } from './classic/anforderungen';

/**
 * Wie viel noch hinaus muss — die Zahlen hinter der Pille in der Kopfzeile.
 *
 * ⚠️ **Zwei Quellen, keine dritte Buchführung.** Die Pakete stehen in `ExamLog` mit
 * `transferred = 'N'`, die Dateien im Dateisystem samt ihrem Übertragungsstand
 * (Tabelle `Dateiuebertragung`). Eine eigene Zählertabelle daneben liefe irgendwann
 * auseinander — und eine Zahl, die nicht stimmt, ist schlechter als keine.
 *
 * ⚠️ **Die Dateien zählt jedes Gleis selbst.** Beide schicken Aufnahmen, sobald sie anfallen,
 * aber sie sammeln verschieden: Relay nimmt die Markierebenen als eigene Art mit und lässt
 * Classic-Kennungen liegen (`anhangStand`), Classic nimmt alles Aufgenommene ohne Beglaubigung
 * und Vorschaubild (`classic/anforderungen.ts::classicDateistand`). Dieselbe Rechnung —
 * vorhandene minus übertragene —, nur auf der Liste, die das jeweilige Gleis wirklich sendet.
 *
 * ⚠️ **Fehler werden geschluckt.** Die Anzeige ist eine Auskunft, kein Betriebsmittel: kann
 * das Dateisystem gerade nicht lesen (im Browser fehlt es ganz), bleibt es beim letzten
 * bekannten Stand, statt dass die Kopfzeile zerbricht.
 */
export async function zaehleRueckstand(store: Store): Promise<Rueckstandszahlen> {
  const zahlen = { ...LEERER_RUECKSTAND, jeArt: { ...LEERER_RUECKSTAND.jeArt } };

  try {
    zahlen.pakete = (await pendingLogs(store)).length;
  } catch {
    // Bleibt bei null — s.o.
  }

  try {
    const dateien =
      aktuelleNamensform() === 'classic'
        ? await classicDateistand(store)
        : await anhangStand(store);
    zahlen.dateien = dateien.offen;
    zahlen.abgewiesen = dateien.abgewiesen;
    zahlen.jeArt = dateien.jeArt;
  } catch {
    // Dasselbe für die Dateien.
  }

  return zahlen;
}
